<template>
    <CModal
      :title="title"
      :color="color"
      size="lg"
      :show.sync="showModal"
    >   
        <CForm id="award_form" method="POST" enctype="multipart/form-data">
            <CRow>
              <CCol md="8">
                <CInput
                  label="Nombre:"
                  id="name"
                  name="name"
                  :lazy="false"
                  :value.sync="$v.form.name.$model"
                  :isValid="checkIfValid('name')"
                  placeholder=""
                  autocomplete="given-name"
                  invalidFeedback="Este campo es requerido y debe ser mayor a 2 caracteres."
                />
              </CCol>
              <CCol md="4">
                <CSelect
                  label="Tipo"
                  id="type"
                  name="type"
                  :value.sync="$v.form.type.$model"
                  :options="typeOptions"
                  @change="onTypeChange"
                />
              </CCol>
            </CRow>
            <CRow v-if="isWalletType">
              <CCol md="12">
                <CSelect
                  label="Modo para Monedero"
                  id="wallet_mode"
                  name="wallet_mode"
                  :value.sync="$v.form.wallet_mode.$model"
                  :options="walletModeOptions"
                  @change="onWalletModeChange"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol md="12">
                <CInput
                  label="Descripción:"
                  id="description"
                  name="description"
                  :lazy="false"
                  :value.sync="$v.form.description.$model"
                  :isValid="checkIfValid('description')"
                  placeholder=""
                  autocomplete="given-description"
                  invalidFeedback="Este campo es requerido y debe ser mayor a 2 caracteres."
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol md="12">
                <CInput
                    type="file"
                    name="image"
                    id="image"
                    label="Imagen del concurso:"
                    :lazy="false"
                    :value.sync="$v.form.image.$model"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol md="4" v-if="!isWalletRange">
                <CInput
                  label="Precio:"
                  type="number"
                  id="price"
                  name="price"
                  :lazy="false"
                  :value.sync="$v.form.price.$model"
                  :isValid="checkIfValid('price')"
                  placeholder=""
                  autocomplete="given-price"
                  invalidFeedback="Este campo es requerido."
                />
              </CCol>
              <CCol md="4" v-if="!isWalletRange">
                <CInput
                  label="Disponibilidad:"
                  type="number"
                  id="stock"
                  name="stock"
                  :lazy="false"
                  :value.sync="$v.form.stock.$model"
                  :isValid="checkIfValid('stock')"
                  placeholder=""
                  autocomplete="given-stock"
                  invalidFeedback="Este campo es requerido."
                />
              </CCol>
              <CCol md="4" v-if="!isWalletRange">
                <CInput
                  label="Ciudad:"
                  type="text"
                  id="city"
                  name="city"
                  :lazy="false"
                  :value.sync="$v.form.city.$model"
                  placeholder=""
                  autocomplete="given-city"
                  invalidFeedback="Este campo es requerido."
                />
              </CCol>
            </CRow>
            <CRow v-if="isWalletRange">
              <CCol md="4">
                <CInput
                  label="Inicio Rango:"
                  type="number"
                  id="range_start"
                  name="range_start"
                  :lazy="false"
                  :value.sync="$v.form.range_start.$model"
                  :isValid="checkIfValid('range_start')"
                  placeholder=""
                  invalidFeedback="Este campo es requerido."
                >
                  <template #append>
                    <CIcon
                      name="cil-info"
                      class="text-muted"
                      v-c-tooltip.hover="'Monto inicial del rango para canje en monedero.'"
                    />
                  </template>
                </CInput>
              </CCol>
              <CCol md="4">
                <CInput
                  label="Fin Rango:"
                  type="number"
                  id="range_end"
                  name="range_end"
                  :lazy="false"
                  :value.sync="$v.form.range_end.$model"
                  :isValid="checkIfValid('range_end')"
                  placeholder=""
                  invalidFeedback="Este campo es requerido."
                >
                  <template #append>
                    <CIcon
                      name="cil-info"
                      class="text-muted"
                      v-c-tooltip.hover="'Monto final permitido para el rango de monedero.'"
                    />
                  </template>
                </CInput>
              </CCol>
              <CCol md="4">
                <CInput
                  label="Salto de Rango:"
                  type="number"
                  id="range_step"
                  name="range_step"
                  :lazy="false"
                  :value.sync="$v.form.range_step.$model"
                  :isValid="checkIfValid('range_step')"
                  placeholder=""
                  invalidFeedback="Este campo es requerido."
                >
                  <template #append>
                    <CIcon
                      name="cil-info"
                      class="text-muted"
                      v-c-tooltip.hover="'Incremento entre cada valor disponible dentro del rango.'"
                    />
                  </template>
                </CInput>
              </CCol>
            </CRow>
            <CRow v-if="isWalletRange">
              <CCol md="12">
                <CInput
                  label="Ciudad:"
                  type="text"
                  id="city"
                  name="city"
                  :lazy="false"
                  :value.sync="$v.form.city.$model"
                  placeholder=""
                  autocomplete="given-city"
                  invalidFeedback="Este campo es requerido."
                />
              </CCol>
            </CRow>
        </CForm>
        <template #footer>
          <CButton @click="closeModal" color="secondary">Cancelar</CButton>
          <CButton @click="store" :color="color">Aceptar</CButton>
        </template>
    </CModal>
</template>

<script>
import { validationMixin } from "vuelidate"
import { required, minLength, requiredIf } from "vuelidate/lib/validators"
import store from '../../store'

export default {
  name: 'AwardModal',
  props: {

  },
  components: {},
  data () {
    return {
      showModal: false,
      title: "Nuevo Premio",
      color: "info",
      isEdit: false,
      form: this.getEmptyForm(),
      submitted: false,
      fields: [
        {key: 'name', label: 'Nombre'},
        {key: 'actions', label: '', class: 'actions' }
      ],
      typeOptions: [
        {label: 'Puntos para Eventos', value: 'event_points'},
        {label: 'Puntos para Certificados', value: 'card_points'},
        {label: 'Puntos para Premios', value: 'gift_points'},
        {label: 'Puntos para Monedero', value: 'wallet_points'}
      ],
      walletModeOptions: [
        {label: 'Rango', value: 'range'},
        {label: 'Normal', value: 'normal'}
      ],
      link: '',
      item: false
    }
  },
  mounted: async function() {
    
  },
  methods: {
    storeModal () {
      this.showModal = true;
      this.color = "info";
      this.title = 'Nuevo Premio';
      this.isEdit = false;
      this.submitted = false;

      this.form = {
          id: 0,
          name: '',
          description: '',
          type: 'event_points',
          wallet_mode: 'normal',
          stock: '',
          price: '',
          range_start: '',
          range_end: '',
          range_step: '',
          image: null,
          city: ''
      }
    },
    updateModal (item) {
      this.showModal = true;
      this.color = "warning";
      this.title = 'Editar Premio';
      this.isEdit = true;
      this.submitted = false;

      this.item = item;

      this.form = {
          id: item.id,
          name: item.name,
          description: item.description,
          type: item.type,
          wallet_mode: item.type === 'wallet_points' ? (item.wallet_mode || 'range') : 'normal',
          stock: item.stock,
          price: item.price,
          range_start: item.range_start,
          range_end: item.range_end,
          range_step: item.range_step,
          city: item.city
      };

      if (this.form.type === 'wallet_points' && !this.form.wallet_mode) {
        this.form.wallet_mode = 'range';
      }

      this.normalizeWalletFieldsByType(true);
    },
    store () {
      this.$v.$touch();

      if (this.isValid) {
        this.submitted = true;

        const form = document.getElementById("award_form");
        const formData = new FormData(form);

        formData.append("id", this.form.id);

        if(this.form.id > 0){
          this.$emit("update", formData );
        }
        else{
          this.$emit("store", formData );
        }

        this.closeModal();
      }
    },
    closeModal () {
      this.showModal = false;

      this.form = this.getEmptyForm()
      this.submitted = false
      this.$v.$reset()
    },
    getEmptyForm () {
      return {
          id: 0,
          name: '',
          description: '',
          type: 'event_points',
          wallet_mode: 'normal',
          stock: '',
          price: '',
          range_start: '',
          range_end: '',
          range_step: '',
          image: null,
          city: ''
      }
    },
    onTypeChange () {
      this.normalizeWalletFieldsByType(false);
    },
    onWalletModeChange () {
      this.normalizeWalletFieldsByMode();
    },
    normalizeWalletFieldsByType (preserveWalletMode = false) {
      if (this.form.type === 'wallet_points') {
        if (!preserveWalletMode || !['range', 'normal'].includes(this.form.wallet_mode)) {
          this.form.wallet_mode = 'range';
        }
      } else {
        this.form.wallet_mode = 'normal';
      }

      this.normalizeWalletFieldsByMode();
    },
    normalizeWalletFieldsByMode () {
      if (this.isWalletRange) {
        this.form.price = '';
        this.form.stock = '';
      } else {
        this.form.range_start = '';
        this.form.range_end = '';
        this.form.range_step = '';
      }
    },
    checkIfValid (fieldName) {
      const field = this.$v.form[fieldName]
      if (!field.$dirty) {
        return null
      }
      
      return !(field.$invalid || field.$model === '')
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    },
  },
  computed: {
    formString () { return JSON.stringify(this.form, null, 4) },
    isValid () { return !this.$v.form.$invalid },
    isDirty () { return this.$v.form.$anyDirty },
    isWalletType () { return this.form.type === 'wallet_points' },
    isWalletRange () { return this.form.type === 'wallet_points' && this.form.wallet_mode === 'range' },
  },
  mixins: [validationMixin],
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(3)
      },
      description: {
        required,
        minLength: minLength(3)
      },
      type: {
        required
      },
      wallet_mode: {
        required: requiredIf(function() {
          return this.form.type === 'wallet_points'
        })
      },
      stock: {
        required: requiredIf(function() {
          return !(this.form.type === 'wallet_points' && this.form.wallet_mode === 'range')
        })
      },
      price: {
        required: requiredIf(function() {
          return !(this.form.type === 'wallet_points' && this.form.wallet_mode === 'range')
        })
      },
      range_start: {
        required: requiredIf(function() {
          return this.form.type === 'wallet_points' && this.form.wallet_mode === 'range'
        })
      },
      range_end: {
        required: requiredIf(function() {
          return this.form.type === 'wallet_points' && this.form.wallet_mode === 'range'
        })
      },
      range_step: {
        required: requiredIf(function() {
          return this.form.type === 'wallet_points' && this.form.wallet_mode === 'range'
        })
      },
      image:{

      },
      city: {
        
      },
    }
  },
}
</script>